module.exports = __webpack_public_path__ + "img/swap.50ea37a0.svg";